import React from 'react'

import { Region, RegionDetail } from 'api/region/useAPIRegion'

import { RegionType } from 'types/region-type'

import { useRegionHook } from './useRegionHook'

export const RegionContextDefaultValue: {
  isLoadingRegions: boolean
  isLoadingRegionDetail: boolean
  regionData: Region[]
  provinceData: RegionDetail[]
  allRegionData: RegionDetail[]
  getRegionNameByRegionId: (regionId: string) => string
  getRegionTypeByRegionId: (regionId: string) => RegionType
  regionDetail: RegionDetail
  setSelectedRegion: (region: RegionDetail) => void
  resetSelectedRegion: () => void
} = {
  isLoadingRegions: true,
  regionData: [],
  provinceData: [],
  allRegionData: [],
  getRegionNameByRegionId: (regionId: string) => regionId,
  getRegionTypeByRegionId: (): RegionType => RegionType.DEFAULT,
  isLoadingRegionDetail: true,
  regionDetail: {
    id: '',
    name: '',
    type: RegionType.KABUPATEN,
  },
  setSelectedRegion: (region) => region,
  resetSelectedRegion: () => null,
}

export const RegionContext = React.createContext(RegionContextDefaultValue)

RegionContext.displayName = 'RegionContext'

export function useRegionContext() {
  const context = React.useContext(RegionContext)
  if (context === undefined) {
    throw new Error('useRegionContext must be used within a RegionProvider')
  }
  return context
}

export function WithRegionContext(props: any) {
  const regionHookData = useRegionHook()

  return <RegionContext.Provider value={regionHookData} {...props} />
}
